import axios from "src/lib/axios";

export const getShippingOrderList = ({
  keyword,
  page,
  page_size,
  status,
  date,
  seller,
  sortOrder,
  sortBy,
  carrier,
}) => {
  return axios.get(`/shippings`, {
    params: {
      keyword,
      status,
      scheduleDate: date,
      page,
      limit: page_size,
      sellers: seller,
      sortOrder,
      sortBy,
      carrier,
    },
  });
};

export const getShippingOrder = (id) => axios.get(`/shippings/${id}`);
export const updateShippingOrder = (id, info) =>
  axios.put(`/shippings/${id}`, info, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });

export const getShippingOrderCsv = ({
  keyword,
  status,
  date,
  seller,
  sortOrder,
  sortBy,
  carrier,
}) => {
  return axios.get(`/shippings/csv`, {
    params: {
      keyword,
      status,
      scheduleDate: date,
      sellers: seller,
      sortOrder,
      sortBy,
      carrier,
    },
  });
};
